import React, { useState, useEffect, Fragment } from "react";
import IntlMessages from "../helpers/IntlMessages";
import "./../date-picker.css";
import { Calendar } from "react-modern-calendar-datepicker";
import moment from "moment";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  FormGroup,
  Input,
  Label,
} from "reactstrap";

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
const BMB_BOOKING_ENGINE =
  process.env.REACT_APP_API_URL + "/booking-engine-data";
const AMADUES = process.env.REACT_APP_PARTNER_URL + "/";
let currentDate = moment().add(1, "days").format("YYYY-MM-DD");
function MewsAvailability({
  data,
  gid,
  pid,
  api,
  lang,
  integration,
  closeAvailblityForm,
  addLinks,
  propertyCurrency,
  buttonColor,
  roomdata
}) {
  const [rooms, setRooms] = useState(1);
  const [promoCode, setPromoCode] = useState("");
  const [roomTypeCode, setRoomTypeCode] = useState("");
  const [adults, setAdults] = useState(2);
  const [children, setChildren] = useState(0);
  const [nights, setNights] = useState(0);
  const [children_age, setChildren_age] = useState([]);
  const [ratePlanCode, setRatePlanCode] = useState("");
  const [datesData, setDatesData] = useState([]);
  const [disableDays, setDisableDays] = useState([]);
  const [availablePrice, setAvaialbelPrice] = useState();
  const [readyToBook, setReadyToBook] = useState(false);
  const [disableCheckInDate, setDisableCheckInDate] = useState([]);
  const [showModel, setShowModel] = useState(false);
  const [dates, setDates] = useState(null);
  const [minimumDate, setMinimumDate] = useState({
    year: moment().add(1, "days").year(),
    month: moment().add(1, "days").month() + 1,
    day: moment().add(1, "days").date(),
  });
  const [priceLoading, setPriceLoading] = useState(false);
  const defaultValue = {
    year: 2023,
    month: 12,
    day: 1,
  };
  const [selectedDayRange, setSelectedDayRange] = useState({
    from: null,
    to: null,
  });

  const handleCheckAvailability = (
    startDate,
    endDate,
    adultsCount,
    childrensCount,
    roomTypeCode
  ) => {
    const fromDate = startDate;
    const toDate = endDate;
    setRooms(1);
    setPriceLoading(true);
    let daysDiff = moment(toDate).diff(startDate, "days");
    setAvaialbelPrice();
    let query = "";
    if (roomTypeCode !== 'All' && roomTypeCode !== '')
      query += "&roomType=" + roomTypeCode;
    fetch(
      process.env.REACT_APP_PARTNER_URL +
      `/public/availability/${integration.Id}?group_id=` +
      gid +
      "&adults=" +
      adultsCount +
      "&children=" +
      childrensCount +
      "&dateIn=" +
      moment(fromDate).format("YYYY-MM-DD") +
      "&dateOut=" +
      moment(toDate).format("YYYY-MM-DD") +
      "&currency=" +
      propertyCurrency +
      "&channel=" + integration.Channel +
      "&rooms=" + 1 + query,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((json) => {
        if (integration.Channel === 'SHRCRS') {
          if (json?.dates && json.dates.length > 0) {
            if (roomTypeCode !== 'All' && roomTypeCode !== '') {
              setAvaialbelPrice(
                `AVAILABLE, ${propertyCurrency} ${json?.dates[0].selectedRate?.price}/night`
              );
            } else {
              let obj = json.dates.reduce(function (prev, curr) {
                return prev.selectedRate.price < curr.selectedRate.price ? prev : curr;
              });
              setAvaialbelPrice(
                `AVAILABLE, ${propertyCurrency} ${obj.selectedRate?.price}/night`
              );
            }
          } else {
            setAvaialbelPrice(
              `No Availability for your selection, try with different dates`
            );
            setReadyToBook(false);
          }
          // setAvaialbelPrice(
          //   `AVAILABLE, ${propertyCurrency} ${price[0]}/night${roomAdults === 1 ? "/person" : ""}`
          // );
          setReadyToBook(true);
        } else {
          let price = [];
          let rooms = 1;
          let roomAdults = 0;
          let roomCategoryAvailabilities = json.RoomCategoryAvailabilities;
          if (
            roomCategoryAvailabilities !== undefined &&
            roomCategoryAvailabilities.length > 0
          ) {
            if (
              roomCategoryAvailabilities[0]?.RoomOccupancyAvailabilities &&
              roomCategoryAvailabilities[0].RoomOccupancyAvailabilities.length > 0
            ) {
              let details =
                roomCategoryAvailabilities[0]?.RoomOccupancyAvailabilities[0];
              roomAdults = details.AdultCount;
              if (
                details.AdultCount >= adultsCount &&
                details.ChildCount >= childrensCount
              ) {
                if (details.Pricing.length === 1) {
                  price.push(
                    details.Pricing[0].Price.AveragePerNight[propertyCurrency]
                  );
                } else {
                  details.Pricing.map((d) => {
                    price.push(d.Price.AveragePerNight[propertyCurrency]);
                  });
                }
              } else {
                let availableRooms = roomCategoryAvailabilities[0].AvailableRoomCount;
                let remainingAdults = details.AdultCount === 1 ? adultsCount - details.AdultCount : adultsCount % details.AdultCount;
                if (remainingAdults > 0 && remainingAdults < availableRooms) {
                  price.push(
                    details.Pricing[0].Price.AveragePerNight[propertyCurrency]
                  );
                  setRooms(rooms + remainingAdults);
                }
              }
            }
          }
          if (price.length > 0) {
            if (price.length === 0) {
              setAvaialbelPrice(
                `AVAILABLE, FROM ${propertyCurrency} ${Math.round(price[0]).toFixed(2)}/night${roomAdults === 1 ? "/person" : ""}`
              );
              setReadyToBook(true);
            } else {
              setAvaialbelPrice(
                `AVAILABLE, FROM ${propertyCurrency} ${Math.round(Math.min(
                  ...price
                )).toFixed(2)}/night${roomAdults === 1 ? "/person" : ""}`
              );
              setReadyToBook(true);
            }
          } else {
            setAvaialbelPrice(
              `No Availability for your selection, try with different dates`
            );
            setReadyToBook(false);
          }
        }
        setPriceLoading(false);
      })
      .catch((err) => setPriceLoading(false));
  };

  useEffect(() => {
    if (integration.ShowRatesSelectedRoom === true) {
      var payload = {
        propertyId: data.pid,
        roomId: data.roomId,
        languageCode: "en",
      };

      fetch(process.env.REACT_APP_API_URL + "/room", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((json) => {
          if (json.result.providerRoomCode !== undefined && json.result.providerRoomCode !== null)
            setRoomTypeCode(json.result.providerRoomCode);
        });
    }
  }, integration);

  useEffect(() => {
    if (dates?.toDate && dates.toDate !== "")
      handleCheckAvailability(dates.fromDate, dates.toDate, adults, children, roomTypeCode);
  }, [dates]);

  const handleRoomListChange = (e) => {
    setRoomTypeCode(e.target.value);
    if (e.target.value !== "") {
      if (dates?.toDate && dates.toDate !== "")
        handleCheckAvailability(
          dates.fromDate,
          dates.toDate,
          adults,
          children,
          e.target.value
        );
    } else {
      if (dates?.toDate && dates.toDate !== "")
        handleCheckAvailability(dates.fromDate, dates.toDate, adults, children, "");
    }
  }

  const handleAdultsChange = (e) => {
    setAdults(e.target.value);
    handleCheckAvailability(
      dates.fromDate,
      dates.toDate,
      e.target.value,
      children,
      roomTypeCode
    );
  };

  const handleChildrenChange = (e) => {
    setChildren(e.target.value);
    if (data.bookingEngineUrl.includes("{CHILDREN_AGE}")) {
      let childrenValue = parseInt(e.target.value);
      let childrenAge = [...children_age];
      if (childrenAge.length > childrenValue) {
        let arr = [];
        for (var i = 0; i < childrenValue; i++) {
          arr.push(childrenAge[i]);
        }
        childrenAge = arr;
      } else {
        for (var i = childrenAge.length; i < childrenValue; i++) {
          childrenAge.push({
            id: i + 1,
            ["children_age_" + (i + 1)]: "",
          });
        }
      }
      setChildren_age(childrenAge);
    }
    handleCheckAvailability(
      dates.fromDate,
      dates.toDate,
      adults,
      e.target.value,
      roomTypeCode
    );
  };

  const handleChangeChildrenAge = (e, id) => {
    let childrenAge = [...children_age];
    childrenAge = children_age.map((item) => {
      if (item.id === id) {
        return { ...item, [e.target.name]: e.target.value };
      } else {
        return { ...item };
      }
    });
    setChildren_age(childrenAge);
    handleCheckAvailability(dates.fromDate, dates.toDate, adults, children, roomTypeCode);
  };

  const handlePromoCodeChange = (e) => {
    setPromoCode(e.target.value);
  };

  const handleSelectedDayRange = (dates) => {
    setShowModel(false);
    if (
      disableCheckInDate.filter(
        (f) =>
          f.year == dates.from.year &&
          f.month == dates.from.month &&
          f.day == dates.from.day
      ).length > 0
    ) {
      setShowModel(true);
      setSelectedDayRange({ from: null, to: null });
      setDates(null);
    } else if (
      disableCheckInDate.filter(
        (f) =>
          f.year == dates.from.year &&
          f.month == dates.from.month &&
          f.day == dates.from.day &&
          f.year == dates.to.year &&
          f.month == dates.to.month &&
          f.day == dates.to.day
      ).length > 0
    ) {
      setShowModel(true);
      setSelectedDayRange({ from: null, to: null });
      setDates(null);
    } else if (
      disableDays.filter((f) => f.year == dates.from.year &&
        f.month == dates.from.month &&
        f.day == dates.from.day).length === 0 &&
      (dates.to === null
        ? true
        : disableDays.filter((f) => f.year == dates.to.year &&
          f.month == dates.to.month &&
          f.day == dates.to.day).length === 0)
    ) {
      setSelectedDayRange(dates);
      var fromDate = "";
      var toDate = "";
      if (dates.from !== null) {
        fromDate = moment({
          year: dates.from.year,
          month: dates.from.month - 1,
          day: dates.from.day,
        }).format("YYYY-MM-DD");
      }
      if (dates.to !== null) {
        toDate = moment({
          year: dates.to.year,
          month: dates.to.month - 1,
          day: dates.to.day,
        }).format("YYYY-MM-DD");
      }
      setDates({
        fromDate: fromDate,
        toDate: toDate,
      });
      let night = 0;
      if (dates.from !== null && dates.to !== null) {
        let fromDateStr =
          dates.from.year + "-" + dates.from.month + "-" + dates.from.day;
        let toDateStr =
          dates.to.year + "-" + dates.to.month + "-" + dates.to.day;
        const fromDate = moment(fromDateStr).format("YYYY-MM-DD");
        const toDate = moment(toDateStr).format("YYYY-MM-DD");
        night = calculateNights(fromDate, toDate);
        if (datesData.length > 0) {
          const fromDateData = datesData.filter(
            (f) => f.date === moment(fromDateStr).format("YYYY-MM-DD")
          );
          const toDateData = datesData.filter(
            (f) => f.date === moment(toDateStr).format("YYYY-MM-DD")
          );
          if (
            fromDateData.length > 0 &&
            toDateData.length > 0 &&
            fromDateData[0].rate.ratePlanCode ===
            toDateData[0].rate.ratePlanCode
          )
            setRatePlanCode(fromDateData[0].rate.ratePlanCode);
        }
      }

      setNights(night);
    }
  };

  const calculateNights = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    let dayCount = 0;
    while (end > start) {
      dayCount++;
      start.setDate(start.getDate() + 1);
    }
    return dayCount;
  };

  const submit = () => {
    if (data !== undefined && readyToBook) {
      const fromDate = dates.fromDate;
      const toDate = dates.toDate;
      let childAge = "";
      let childrenAge = children_age;
      if (childrenAge.length > 0) {
        childrenAge.map((item, index) => {
          childAge += item["children_age_" + (index + 1)];
          if (item["children_age_" + (index + 1)] !== "" && childAge !== "" && childrenAge.length > (index + 1)) {
            childAge += data.delimiter;
          }
        });
      }
      let bookingUrl = data.bookingEngineUrl;
      if (children === 0) {
        if (bookingUrl.includes("{ADULTS}-{CHILDREN_AGE}")) {
          bookingUrl = bookingUrl.replace(
            "{ADULTS}-{CHILDREN_AGE}",
            "{ADULTS}{CHILDREN_AGE}"
          );
        }
      }
      bookingUrl = bookingUrl.replace(
        "{CHECK_IN}",
        moment(fromDate).format(data.dateFormat)
      );
      bookingUrl = bookingUrl.replace(
        "{CHECK_OUT}",
        moment(toDate).format(data.dateFormat)
      );
      bookingUrl = bookingUrl.replace("{ADULTS}", adults);
      bookingUrl = bookingUrl.replace("{CHILDREN}", children);
      bookingUrl = bookingUrl.replace("{LANGUAGE}", lang);
      //bookingUrl = bookingUrl.replace("{ROOM_TYPE}", roomTypeCode);
      bookingUrl = bookingUrl.replace("mewsRoom=null", "mewsRoom=" + roomTypeCode);
      bookingUrl = bookingUrl.replace("{NIGHTS}", nights);
      bookingUrl = bookingUrl.replace("{CHILDREN_AGE}", childAge);
      bookingUrl = bookingUrl.replace("{PROMO_CODE}", promoCode);

      if (roomTypeCode !== undefined && roomTypeCode !== null && roomTypeCode !== "") {
        const hashIndex = bookingUrl.indexOf("#");
        bookingUrl =
          bookingUrl.slice(0, hashIndex) +
          "&roomtypeid=" +
          roomTypeCode +
          bookingUrl.slice(hashIndex);
      }
      if (ratePlanCode !== "") {
        const hashIndex = bookingUrl.indexOf("#");
        bookingUrl =
          bookingUrl.slice(0, hashIndex) +
          "&rateplanid=" +
          ratePlanCode +
          bookingUrl.slice(hashIndex);
      }

      var body = {
        groupId: data.gid,
        propertyId: data.pid,
        checkInDate: moment(fromDate).format("YYYY-MM-DD"),
        checkOutDate: toDate !== "" ? moment(toDate).format("YYYY-MM-DD") : "",
        nights: nights,
        adults: adults,
        childrens: children,
        creator: "webview",
        promoCode: promoCode,
      };
      let msg = "Customer referred to the booking page for dates";
      msg +=
        " " +
        months[selectedDayRange.from.month - 1] +
        " " +
        selectedDayRange.from.day +
        ", " +
        selectedDayRange.from.year +
        " to " +
        months[selectedDayRange.to.month - 1] +
        " " +
        selectedDayRange.to.day +
        ", " +
        selectedDayRange.to.year +
        "";
      if (adults !== 0) {
        msg += ", for " + adults + " adults";
      }
      if (children !== 0) {
        msg += " and " + children + " children";
      }
      api.sendActivity({
        type: "WEB_CHAT/SEND_EVENT",
        payload: {
          name: "webchat/booking",
          value: {
            msg: `${msg}`,
          },
        },
      });
      fetch(`${BMB_BOOKING_ENGINE}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      addLinks(bookingUrl);
      closeAvailblityForm();
      if (window.parent) {
        window.parent.postMessage("openUrl:" + bookingUrl + "", "*");
      } else {
        window.location = bookingUrl;
      }
    }
  };

  return (
    <Fragment>
      <div className="chat_box_popup_new">
        <div className="endchat_popup area">
          <h1 className="availablityh1">
            {""}
            {roomdata && roomdata.length > 0 ?
              <Fragment>
                <Input style={{width:'90%'}}
                  type="select"
                  name="roomTypeCode"
                  value={roomTypeCode == "" ? "" : roomdata.filter(f => f.providerRoomCode == roomTypeCode)[0].providerRoomCode}
                  onChange={(e) => handleRoomListChange(e)}
                >
                  <option value={""}>All</option>
                  {roomdata.map((item, i) => (
                    <option value={item.providerRoomCode}>{item.name}</option>
                  ))}
                </Input>
              </Fragment> : <IntlMessages id="check.availabity" />}
            {""}
  <img style={{float: 'right', top: '20px', position: 'absolute', right: '4px'}}  onClick={closeAvailblityForm} src="/res/cross_icon.jpg" width="15" height="15" />          </h1>
          <Row>
            <Col xs={12}>
              <Calendar
                value={selectedDayRange}
                minimumDate={minimumDate}
                disabledDays={disableDays}
                onChange={handleSelectedDayRange}
                style={{ height: "32.7em" }}
                renderFooter={() => (
                  <Fragment>
                    {priceLoading === true && (
                      <div id="spinner" className="container-load">
                        <div className="loading"></div>
                      </div>
                    )}
                  </Fragment>
                )}
              />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col xs={6} style={{ margin: "0" }}>
              <FormGroup>
                <Label>
                  <IntlMessages id="check.availabity.adults" />
                </Label>
                <Input
                  id="roomCode"
                  type="hidden"
                  name="roomcode"
                  value={roomTypeCode}
                ></Input>
                <Input
                  id="adult_count"
                  type="select"
                  name="adults"
                  value={adults}
                  onChange={handleAdultsChange}
                >
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                  <option>6</option>
                </Input>
              </FormGroup>
            </Col>
            <Col xs={6} style={{ margin: "0" }}>
              <FormGroup>
                <Label>
                  <IntlMessages id="check.availabity.children" />
                </Label>
                <Input
                  id="children_count"
                  type="select"
                  name="children"
                  value={children}
                  onChange={handleChildrenChange}
                >
                  <option>0</option>
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                  <option>6</option>
                </Input>
              </FormGroup>
            </Col>
            {children_age.length > 0 &&
              children_age.map((element, i) => (
                <Col xs={4} style={{ margin: "0" }} key={i}>
                  <FormGroup>
                    <Label>
                      <IntlMessages id="check.availabity.child.age" /> {i + 1}
                    </Label>
                    <Input
                      type="select"
                      name={"children_age_" + (i + 1)}
                      value={element[i]}
                      onChange={(e) => handleChangeChildrenAge(e, element.id)}
                    >
                      <option>0</option>
                      <option>1</option>
                      <option>2</option>
                      <option>3</option>
                      <option>4</option>
                      <option>5</option>
                      <option>6</option>
                      <option>7</option>
                      <option>8</option>
                      <option>9</option>
                      <option>10</option>
                      <option>11</option>
                      <option>12</option>
                    </Input>
                  </FormGroup>
                </Col>
              ))}
          </Row>
          {data.bookingEngineUrl.includes("{PROMO_CODE}") && (
            <Row>
              <Col xs={12} style={{ margin: "0" }} className="mb-3">
                <Input
                  type="text"
                  value={promoCode}
                  placeholder={"Promo Code"}
                  onChange={handlePromoCodeChange}
                />
              </Col>
            </Row>
          )}
          {selectedDayRange.from !== null && selectedDayRange.to !== null && (
            <button
              className="availablity_button"
              // style={{ backgroundColor: buttonColor ? buttonColor : 'lightgray' }}
              style={{
                backgroundColor: `${readyToBook ? (buttonColor || "#0eca2d") : "#FFBF00"}`,
              }}
              onClick={submit}
            >
              <span className="mb-2">{availablePrice}</span>
              <br />
              {readyToBook && (
                <span style={{ textDecoration: "underline" }}>
                  Book Now
                </span>
              )}
            </button>
          )}
          <button className="cancelchat_button" onClick={closeAvailblityForm}>
            {""}
            <IntlMessages id="check.availabity.cancel" />
            {""}
          </button>
        </div>
      </div>
    </Fragment>
  );
}

export default MewsAvailability;
